export default [
    {
        path: "/xiaomifeng",
        name: "xiaomifeng__root__",
        redirect: {
            name: "xiaomifeng-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "xiaomifeng",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "xiaomifeng-index",
                component: () => import("@/views/xmf/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "admin",
                    affix: true,
                    group: 512,
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/system-config",
        name: "xiaomifeng-system-config",
        meta: {
            title: "公共配置",
            icon: "all-setting",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-system-config-index",
                component: () => import("@/views/xmf/system-config/index.vue"),
                meta: {
                    title: "公共配置",
                    icon: "all-setting",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/users",
        name: "xiaomifeng-user",
        meta: {
            title: "用户中心",
            icon: "users",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-user-index",
                component: () => import("@/views/xmf/user/index.vue"),
                meta: {
                    title: "用户中心",
                    icon: "users",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-user-detail",
                component: () => import("@/views/xmf/user/detail.vue"),
                hidden: true,
                meta: {
                    title: "用户详情",
                    icon: "users",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/realname",
        name: "xiaomifeng-realname",
        meta: {
            title: "实名认证",
            icon: "protection",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-realname-index",
                component: () => import("@/views/xmf/realname/index.vue"),
                meta: {
                    title: "实名认证",
                    icon: "protection",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-realname-detail",
                component: () => import("@/views/xmf/realname/detail.vue"),
                hidden: true,
                meta: {
                    title: "实名详情",
                    icon: "protection",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/role-pending",
        name: "xiaomifeng-role-pending",
        meta: {
            title: "角色申请",
            icon: "user",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-role-pending-index",
                component: () => import("@/views/xmf/role-pending/index.vue"),
                meta: {
                    title: "角色申请",
                    icon: "user",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/workers",
        name: "xiaomifeng-worker",
        meta: {
            title: "工人审核",
            icon: "maintenance",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-worker-index",
                component: () => import("@/views/xmf/worker/index.vue"),
                meta: {
                    title: "工人审核",
                    icon: "maintenance",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-worker-detail",
                component: () => import("@/views/xmf/worker/detail.vue"),
                hidden: true,
                meta: {
                    title: "工人详情",
                    icon: "maintenance",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/employers",
        name: "xiaomifeng-employer",
        meta: {
            title: "园区审核",
            icon: "organization",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-employer-index",
                component: () => import("@/views/xmf/employer/index.vue"),
                meta: {
                    title: "园区审核",
                    icon: "organization",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-employer-detail",
                component: () => import("@/views/xmf/employer/detail.vue"),
                hidden: true,
                meta: {
                    title: "园区详情",
                    icon: "organization",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/teams",
        name: "xiaomifeng-team",
        meta: {
            title: "车队审核",
            icon: "truck",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-team-index",
                component: () => import("@/views/xmf/team/index.vue"),
                meta: {
                    title: "车队审核",
                    icon: "truck",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-team-detail",
                component: () => import("@/views/xmf/team/detail.vue"),
                hidden: true,
                meta: {
                    title: "车队详情",
                    icon: "truck",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/pending",
        name: "xiaomifeng-pending",
        meta: {
            title: "写前审核",
            icon: "document",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-pending-index",
                component: () => import("@/views/xmf/pending/index.vue"),
                meta: {
                    title: "写前审核",
                    icon: "document",
                    affix: false,
                },
            },
            {
                path: ":id",
                name: "xiaomifeng-pending-detail",
                component: () => import("@/views/xmf/pending/detail.vue"),
                hidden: true,
                meta: {
                    title: "审核详情",
                    icon: "document",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/breadcrumb",
        name: "xiaomifeng-breadcrumb",
        meta: {
            title: "前端配置",
            icon: "announcement",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-breadcrumb-index",
                component: () => import("@/views/xmf/breadcrumb/index.vue"),
                meta: {
                    title: "前端配置",
                    icon: "announcement",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/document",
        name: "xiaomifeng-document",
        meta: {
            title: "文档中心",
            icon: "cms-document",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "documentXiaomifengList",
        },
        children: [
            {
                path: "bee",
                name: "documentXiaomifengList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "小蜜蜂文档",
                    icon: "document",
                    affix: false,
                    type: "bee",
                    detailRouteName: "xiaomifengDocument",
                },
            },
            {
                path: "detail/:id(\\d+)?",
                name: "xiaomifengDocument",
                hidden: true,
                component: () => import("@/views/cms/source/document/document_form2.vue"),
                meta: {
                    title: "文档内容",
                    affix: false,
                    activeMenu: "/xiaomifeng/document/bee",
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/dict/skills",
        name: "xiaomifeng-dict-skills",
        meta: {
            title: "技能字典",
            icon: "dict",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-dict-skills-index",
                component: () => import("@/views/xmf/dict/skill.vue"),
                meta: {
                    title: "技能字典",
                    icon: "dict",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/xiaomifeng/dict/crops",
        name: "xiaomifeng-dict-crops",
        meta: {
            title: "作物字典",
            icon: "eco",
            parent: "xiaomifeng",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "xiaomifeng-dict-crops-index",
                component: () => import("@/views/xmf/dict/crop.vue"),
                meta: {
                    title: "作物字典",
                    icon: "eco",
                    affix: false,
                },
            },
        ],
    },
];
